<div class="wrapper">
  @if (badge(); as badge) {
    <div class="badge" [style.background-color]="'var(' + badge + ')'" [style.box-shadow]="'var(' + badge + '-sh)'"></div>
  }
  <div class="f-c">
    <span class="t-md">{{ text() | mnTranslate }}</span>
    @if (message(); as message) {
      <span class="c-20 t-sm">{{ message | mnTranslate }}</span>
    }
  </div>
</div>
